var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "fade", mode: "out-in" } },
    [
      _vm.loading
        ? _c("loader")
        : _c(
            "form",
            { staticClass: "quotetool__step quotetool__step-confirmation" },
            [
              _vm.signingError == false
                ? _c("section", { staticClass: "section--light-blue" }, [
                    _c("div", { staticClass: "container text-center" }, [
                      _c("h2", { staticClass: "quotetool__step-heading" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.labels.stepFiveTitle) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "container--max-width-750" }, [
                        _c("p", [_vm._v(_vm._s(_vm.labels.stepFiveSummary))]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn btn--inline btn-download",
                          attrs: {
                            href: _vm.documentUrl,
                            target: "_blank",
                            type: "button",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.labels.stepFiveDownloadContactButton)
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.signingError == false
                ? _c("section", [
                    _c("div", { staticClass: "container" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-6 text-center quotetool__step-confirmation-column",
                          },
                          [
                            _c("h2", [
                              _vm._v(
                                _vm._s(_vm.labels.stepFiveWhatsNextHeading)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(_vm.labels.stepFiveWhatsNextText)),
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.labels.stepFiveWhatsNextList
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "btn btn--inline btn--chevron",
                                attrs: {
                                  href: _vm.labels.stepFiveFAQButtonLink,
                                },
                              },
                              [_vm._v(_vm._s(_vm.labels.stepFiveFAQButton))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-6 text-center quotetool__step-confirmation-column",
                          },
                          [
                            _c("h2", [
                              _vm._v(
                                _vm._s(_vm.labels.stepFiveAddServicesHeading)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.labels.stepFiveAddServicesText)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.labels.stepFiveAddServicesHeadingList
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "btn btn--inline btn--chevron",
                                attrs: {
                                  href: _vm.labels
                                    .stepFiveFindOutMoreButtonLink,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.labels.stepFiveFindOutMoreButton)
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-xs-12 text-center" }, [
                          _c("p", [
                            _vm._v(_vm._s(_vm.labels.stepFiveComplianceText)),
                          ]),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.signingError
                ? _c("section", [
                    _c("div", { staticClass: "container" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 text-center quotetool__step-confirmation-column",
                          },
                          [
                            _c("h2", [
                              _vm._v(
                                _vm._s(_vm.labels.stepFiveSigningErrorHeading)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.labels.stepFiveSigningErrorMessage)
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }